// extracted by mini-css-extract-plugin
export default {"container":"_D-z","dimension":"aE-z","dimensionLabels":"bE-z"};